import { Redirect, Router } from "@reach/router";
import { User, UserType } from "./utils/helpers/types";
import NotFound from "./pages/not-found";
import "./styles/globals.scss";
import { RouteGuard } from "./utils/helpers/role-helpers";
import FintechManagement from "./pages/issuer-management";
import CertificateAuthority from "./pages/certificate-authority";
import KeyCategoriesPage from "./pages/key-categories";
import KeyMigration from "./pages/key-migration";
import DesKeys from "./pages/des-keys";
import RsaKeys from "./pages/rsa-keys";

const defaultLinkMap: Record<UserType, string> = {
  ISW_ADMIN: "/issuer-management",
};

const getRoutes: (user: User | null) => JSX.Element = (user) => {
  const defaultLink = user ? defaultLinkMap[user.userType] || "/" : "/";

  return (
    <Router>
      <Redirect from="/" to={defaultLink} noThrow />
      <Redirect from="/spa/kms-portlet" to={defaultLink} noThrow />
      <NotFound default />
      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={FintechManagement}
        path="/issuer-management"
      />
      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={CertificateAuthority}
        path="/certificate-authority"
      />
      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={KeyCategoriesPage}
        path="/des-key-groups"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={KeyMigration}
        path="/key-migration"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={DesKeys}
        path="/des-keys"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={RsaKeys}
        path="/rsa-keys"
      />
    </Router>
  );
};

export default getRoutes;
